import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.css.wrap)
  }, [_createElementVNode("div", {
    class: _normalizeClass([_ctx.css.smallbox, _ctx.css.common]),
    onMouseleave: _cache[0] || (_cache[0] = (...args) => $options.onmoueseLeave && $options.onmoueseLeave(...args)),
    onMouseenter: _cache[1] || (_cache[1] = (...args) => $options.onmoueseenter && $options.onmoueseenter(...args)),
    onMousemove: _cache[2] || (_cache[2] = (...args) => $options.onmousemove && $options.onmousemove(...args)),
    style: _normalizeStyle([{
      'background-image': `url(${$data.curImgae})`
    }]),
    ref: "smallbox"
  }, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.css.zhao),
    ref: "zhao"
  }, null, 2), _createElementVNode("div", {
    class: _normalizeClass(_ctx.css.mo),
    ref: "mo"
  }, null, 2)], 38), _createElementVNode("div", {
    class: _normalizeClass(_ctx.css.bigbox),
    ref: "bigbox"
  }, [_createElementVNode("img", {
    ref: "bigimg",
    src: $data.curImgae,
    alt: "",
    class: _normalizeClass(_ctx.css.bigimg)
  }, null, 10, _hoisted_1)], 2), $data.arr.length ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass([_ctx.css.goodsimgs, "row"])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.slice(0, 5), (item, index) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [item ? (_openBlock(), _createElementBlock("div", {
      class: _normalizeClass([_ctx.css.img, _ctx.css.common, {
        [_ctx.css.active]: $data.curImgae == item
      }]),
      onClick: $event => $options.onImageClick(item),
      style: _normalizeStyle([[{
        'background-image': `url(${item})`
      }], {
        "margin": "0 5px"
      }]),
      key: index
    }, null, 14, _hoisted_2)) : _createCommentVNode("", true)], 64);
  }), 256))], 2)) : _createCommentVNode("", true)], 2);
}